import { createSlice } from '@reduxjs/toolkit';

import { fetchUserTeams, fetchUsers, addUserToTeams } from './invitePeopleThunks';

export const initialState = {
    allTeams: [],
    allUserTeams: [],
    allUsers: [],
    loading: false,
    error: false,
};

const InvitePeopleSlice = createSlice({
    name: 'invitePeople',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchUserTeams.pending, state => {
                state.error = false;
                state.loading = true;
            })
            .addCase(fetchUserTeams.fulfilled, (state, { payload }) => {
                state.allUserTeams = payload.data;
                state.loading = false;
            })
            .addCase(fetchUserTeams.rejected, (state, { payload }) => {
                state.error = true;
                state.loading = false;
                alert(payload);
            })
            .addCase(fetchUsers.pending, state => {
                state.error = false;
                state.loading = true;
            })
            .addCase(fetchUsers.fulfilled, (state, { payload }) => {
                state.allUsers = payload.data;
                state.loading = false;
            })
            .addCase(fetchUsers.rejected, (state, { payload }) => {
                state.error = true;
                state.loading = false;
                alert(payload);
            })
            .addCase(addUserToTeams.pending, state => {
                state.error = false;
                state.loading = true;
            })
            .addCase(addUserToTeams.fulfilled, (state, { payload }) => {
                state.loading = false;
            })
            .addCase(addUserToTeams.rejected, (state, { payload }) => {
                state.error = true;
                state.loading = false;
            });
    },
});

export const InvitePeopleReducer = InvitePeopleSlice.reducer;
export const InvitePeopleActions = {
    ...InvitePeopleSlice.actions,
    fetchUserTeams,
    fetchUsers,
    addUserToTeams,
};
